<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    class="elevation-1"
    :pagination="pagination"
    @update:pagination="setPagination"
    :must-sort="true"
    :total-items="totalDocs"
    :rows-per-page-items="customRowsPerPage">
    <template v-slot:items="props">
      <slot v-if="props.item.dependent">
        <tr style="cursor: pointer" @click="selectUpgrade(props.item)">
          <td>
            <v-icon small left>mdi-library-shelves</v-icon>
            {{ props.item.dependent.library.name }}
          </td>
          <td>
            <content-type-icon :type="props.item.dependent.header.content_revision_type" />
          </td>
          <td>
            <kbd>{{ props.item.dependent.header.custom_id }}</kbd>
          </td>
          <td>{{ props.item.dependent.header.metadata.title }}</td>
          <td>{{ props.item.dependent.header.major_revision }}.{{ props.item.dependent.header.minor_revision }}</td>
          <td>{{ props.item.outdated.length }}</td>
        </tr>
      </slot>
    </template>
  </v-data-table>
</template>

<script>
import { outdated, loading, selectUpgrade, selectedUpgrade, setPagination, getPagination } from "../store.js"

import { ContentTypeIcon } from "plant-common"
export default {
  components: { ContentTypeIcon },
  data() {
    return {
      headers: [
        {
          text: "Library",
          value: "dependent.library.name",
          width: "10%"
        },
        {
          text: "Type",
          value: "dependent.header.metadata.content_revision_type",
          width: "25px"
        },
        {
          text: "Custom Id",
          value: "dependent.header.custom_id",
          width: "15%"
        },
        {
          text: "Title",
          width: "75%",
          value: "dependent.header.metadata.title"
        },
        {
          text: "Revision",
          width: "10em",
          sortable: false
        },
        {
          text: "Outdated Dependencies",
          value: "outdatedCount",
          width: "10em"
        }
      ],
      customRowsPerPage: [5, 10, 25, 50]
    }
  },

  computed: {
    outdated,
    loading,
    selectedUpgrade,
    totalDocs() {
      if (!this.outdated) return 0
      return this.outdated.totalDocs
    },
    items() {
      if (!this.outdated) return []
      return this.outdated.docs
    },
    pagination: getPagination
  },
  methods: {
    selectUpgrade,
    setPagination
  }
}
</script>

<style>
</style>